import Button from './Button';
import SearchQuery from './SearchQuery';
import { useLanguage } from '../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

export default function Searchbar({ text, linkType, link, type = 'header' }) {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleNotFound = () => {
    navigate('/notFound');
  };

  const handleRedirect = () => {
    if (linkType === 'internal') {
      navigate(link);
      return;
    } else if (linkType === 'external') {
      window.open(link);
      return;
    } else {
      handleNotFound();
      return;
    }
  };

  return (
    <div
      className={
        'bg-white dark:bg-background-dark dark:text-text-dark rounded-2xl border border-gray flex items-strecth justify-between min-w-0 w-full'
      }
    >
      <SearchQuery text={`${text}`} type={type} />
      <Button type="button" onClick={handleRedirect} category="searchbar" text={t('findOut')} />
      <Button type="button" onClick={handleRedirect} category="searchbarsmall" text={t('go')} />
    </div>
  );
}
